// Keeps only the path, query and hash, so a return URL can never send the browser to another origin.
export function sanitizeReturnUrlPath(rawUrl: string): string | null {
    try {
        const { protocol, pathname, search, hash } = new URL(rawUrl);

        // Only http(s) turns backslashes into slashes, so only there does the // check catch every
        // protocol-relative path, which would resolve to another origin.
        if ((protocol !== "https:" && protocol !== "http:") || pathname.startsWith("//")) {
            return null;
        }

        return pathname + search + hash;
    } catch {
        return null;
    }
}

// For a path taken from the URL, such as a returnTo: anything React Router would refuse is dropped too.
export function sanitizeSameOriginPath(rawPath: string | null, origin: string = window.location.origin) {
    if (!rawPath?.startsWith("/") || rawPath.includes("\\")) {
        return null;
    }

    try {
        const url = new URL(rawPath, origin);

        return url.origin === origin ? sanitizeReturnUrlPath(url.href) : null;
    } catch {
        return null;
    }
}
